module.exports = __webpack_public_path__ + "img/pr-6.acf08d06.png";